module.exports = __webpack_public_path__ + "static/img/logo.1b599580.png";